import { StatusTag } from '../../../components/StatusTag';
import { useT } from '../../../locales';

interface PagoStatusTagProps {
  motivoAnulacion: string | null;
  idEstadoPago: number;
}

export function PagoStatusTag({ motivoAnulacion }: PagoStatusTagProps) {
  const t = useT();
  if (motivoAnulacion) {
    return <StatusTag tone="error">{t('pages.pagos.estadoAnulado')}</StatusTag>;
  }
  return <StatusTag tone="success">{t('pages.pagos.estadoVigente')}</StatusTag>;
}
